export default "__VITE_ASSET__LqE1GtaM__"